import {useCallback, useMemo} from 'react'
import {useSearchParams} from 'react-router-dom'

const DIALOG_PARAM = 'dialog'
const VIOLATION_ID_PARAM = 'violationId'
const FROM_PARAM = 'fromPartyType'
const REL_PARAM = 'relationshipType'
const TO_PARAM = 'toPartyType'
const DIALOG_CREATE = 'create'

export interface CreateEntrySeed {
    fromPartyType: string
    relationshipType: string
    toPartyType: string
}

export interface CreateEntrySeedState {
    seedOpen: boolean
    seed: CreateEntrySeed | null
    clearSeed: () => void
}

export function useCreateEntrySeed(): CreateEntrySeedState {
    const [searchParams, setSearchParams] = useSearchParams()

    const seed = useMemo<CreateEntrySeed | null>(() => {
        const dialog = searchParams.get(DIALOG_PARAM)
        if (dialog !== DIALOG_CREATE) return null
        const fromPartyType = searchParams.get(FROM_PARAM)
        const relationshipType = searchParams.get(REL_PARAM)
        const toPartyType = searchParams.get(TO_PARAM)
        if (!fromPartyType || !relationshipType || !toPartyType) {
            return {fromPartyType: '', relationshipType: '', toPartyType: ''}
        }
        return {fromPartyType, relationshipType, toPartyType}
    }, [searchParams])

    const seedOpen = searchParams.get(DIALOG_PARAM) === DIALOG_CREATE

    const clearSeed = useCallback(() => {
        setSearchParams(
            (prev) => {
                const next = new URLSearchParams(prev)
                next.delete(DIALOG_PARAM)
                next.delete(VIOLATION_ID_PARAM)
                next.delete(FROM_PARAM)
                next.delete(REL_PARAM)
                next.delete(TO_PARAM)
                return next
            },
            {replace: true},
        )
    }, [setSearchParams])

    return {seedOpen, seed, clearSeed}
}
